export default __webpack_public_path__ + "static/media/bg-portal-updates.2be74c2d.webp";